define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Marionette = require("marionette");
    var template = require("ui.components/special-occasion-picker/templates/specialOccasionPicker.tmpl");
    var SpecialOccasionPickerItemDataView = require("ui.components/special-occasion-picker/js/SpecialOccasionPickerItemDataView");
    var Button = require("ui/button/Button");
    var EditDecorator = require("ui.plugins/edit-decorator/js/EditDecorator");
    var Translator = require("i18n/translator");

    var SpecialOccasionPicker = Marionette.ItemView.extend({
        className: "special-occasion-picker-container",
        template: template,
        withUIComponents: true,
        ui: {
            "setSpecialOccasionButton": ".set-special-occasion-button",
            "selectedSpecialOccasionNameContainer": ".selected-special-occasion-name-container",
            "selectedSpecialOccasionName": ".selected-special-occasion-name-container .special-occasion-name",
            "selectedSpecialOccasionDataContainer": ".selected-special-occasion-data-container"
        },
        uiComponents: {
            setSpecialOccasionButton: {
                type: Button,
                options: {
                    el: "view.ui.setSpecialOccasionButton",
                    permutation: Button.PERMUTATION.BTN_SPECIAL_FULL,
                    initState: Button.STATES.ENABLED
                },
                events: {
                    click: "_onEditSpecialOccasionClick"
                }
            },
            selectedSpecialOccasionEditDecorator: {
                type: EditDecorator,
                options: {
                    el: "view.ui.selectedSpecialOccasionNameContainer",
                    permutation: EditDecorator.PERMUTATION.B,
                    enabled: "view.hasEditPrivileges"
                },
                events: {
                    click: "_onEditSpecialOccasionClick"
                }
            },
        },

        customTemplateHelpers: function() {
            return {
                addText: this.addText
            };
        },

        initialize: function(options) {
            this._initialize(options);
        },
        onRender: function() {
            this._onRender();
        },
        getSelection: function() {
            return this._getSelection();
        },
        setSelection: function(model) {
            this._setSelection(model);
        },
        setError: function(isError, errorMsg) {
            this._setError(isError, errorMsg);
        },


        _initialize: function(options) {
            options = options || {};

            this.container = options.container;
            this.addText = _.has(options, "addText") ? options.addText : Translator.translate("LEUIComponents.specialOccasionPicker.add.text");
            this.model = _.has(options, "model") ? options.model : null;
            this.hasEditPrivileges = _.has(options, "hasEditPrivileges") ? options.hasEditPrivileges : true;
        },
        _onRender: function() {
            if (!_.isEmpty(this.container)) {
                this.container.append(this.$el);
            }

            this.uiComponents.setSpecialOccasionButton.setEnabled(this.hasEditPrivileges);
            this._renderSelectedModel();
        },
        _renderSelectedModel: function() {
            var isModelExists = !_.isEmpty(this.model);
            this.ui.setSpecialOccasionButton.toggleClass("hide", isModelExists);
            this.ui.selectedSpecialOccasionNameContainer.toggleClass("hide", !isModelExists);
            this.ui.selectedSpecialOccasionDataContainer.toggleClass("hide", !isModelExists);

            var modelName = (isModelExists) ? this.model.getName() : "";
            this.ui.selectedSpecialOccasionName.text(modelName);

            this._renderSelectedModelData();
        },
        _renderSelectedModelData: function() {
            if (this.uiComponents.pickerItemData) {
                this.uiComponents.pickerItemData.close();
            }

            if (this.model) {
                this.uiComponents.host$.createAndRender("pickerItemData", {
                    type: SpecialOccasionPickerItemDataView,
                    options: {
                        model: this.model,
                        container: this.ui.selectedSpecialOccasionDataContainer
                    }
                });
            }
        },
        _onEditSpecialOccasionClick: function() {
            this.trigger("edit");
        },
        _getSelection: function() {
            var selection = (this.model) ? this.model.id : null;
            return selection;
        },
        _setSelection: function(model) {
            this.model = model;
            this._renderSelectedModel();
        },
        _setError: function(isError, errorMsg) {
            this.uiComponents.setSpecialOccasionButton.setError(isError, errorMsg);
        }
    });

    return SpecialOccasionPicker;

});
